import { useFeatureFlags } from '@/components/FeatureFlagsContext';
import { useFlowState, useSeekerState } from '@/components/AppState';
import { CLIENT_FEATURE_FLAGS, comesFromVhp } from '@/constants';
import { ServiceIdsForSeniorMember, TrafficSource } from '@/types/seeker';

export function useAdultCare() {
  const { czenServiceIdForMember, source } = useSeekerState();
  const { comeFrom, vhpFeatureFlagSharedData } = useFlowState();
  const featureFlags = useFeatureFlags();

  // SEO / SEM requirements
  const isEligibleForAdultCareFlow = czenServiceIdForMember === ServiceIdsForSeniorMember.AdultCare;
  const adultCareFlagValueSEM =
    featureFlags?.flags[CLIENT_FEATURE_FLAGS.GROWTH_SC_SKIP_INDEX_FOR_ADULT_CARE_SEM_LINKS]?.value;
  const adultCareFlagValueSEO =
    featureFlags?.flags[CLIENT_FEATURE_FLAGS.GROWTH_SC_ADULT_CARE_SEO_FLOW]?.value;

  // VHP requirements
  const growthVhpAdultCareTileFlag =
    vhpFeatureFlagSharedData?.[CLIENT_FEATURE_FLAGS.GROWTH_VHP_ADULT_CARE_TILE];
  const isGrowthVhpAdultCareTile =
    comeFrom === comesFromVhp &&
    typeof growthVhpAdultCareTileFlag === 'number' &&
    [2, 3]?.includes(growthVhpAdultCareTileFlag);

  let isAdultCareFlow = false;

  if (source === TrafficSource.SEO) {
    isAdultCareFlow = isEligibleForAdultCareFlow && adultCareFlagValueSEO === 2;
  } else {
    isAdultCareFlow =
      (isEligibleForAdultCareFlow && adultCareFlagValueSEM) || isGrowthVhpAdultCareTile;
  }

  return {
    isAdultCareFlow,
  };
}
